import React, { useState, useEffect, useRef } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import {Grid, TextField, Checkbox } from "@material-ui/core";
import Button from '@mui/material/Button';
import { connect } from "react-redux";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {
  getBookingById,
  getCCPackage,
  postAddRemoveTest,
} from "../../../actions/OffLineSupportActions";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import Payment from "../../payment/index";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      marginTop: "2rem",
      padding: "0.5rem 2rem",
      width: "100%",
    },
    table: {
      maxWidth: "100%",
      margin: "auto",
    },
    packageLink: {
      color: "#ffffff",
      textDecoration: "none",
    },
  })
);

interface Props {
  id: any;
  aid: any;
  type: any;
  ccpackageList: any;
  postAddRemoveTest: any;
  getCCPackage: any;
  getBookingById: any;
  booking: any;
  packageDetails: any;
  setPackages: any;
}

const AddCorporateTest: React.FC<Props> = ({
  id,
  ccpackageList,
  aid,
  type,
  getBookingById,
  booking,
  postAddRemoveTest,
  getCCPackage,
  packageDetails,
  setPackages,
}) => {
  const classes = useStyles();
  const [paid, setPaid] = useState<any>(0);
  const [withoutPayment, setWithoutPayment] = useState<any>(false);
  const [due, setDue] = useState<any>(0);
  const [centreType, setCentreType] = useState<any>("");
  const [paymentInfo, setPaymentInfo] = useState<any>([]);
  const discount= booking.discounted_price && booking.discounted_price.counpon_discount
  const [totalPrice, setTotalPrice] = useState<any>(0);
  const [addnPkgs, setAddnPkgs] = useState<any>([]);
  const [netPrice, setNetPrice] = useState<any>(0);
  const [inputList, setInputList] = useState<any>([
    {
      customerDesignation: booking?.designation,
      designation: booking?.designation,
      customerName: booking?.customer_name,
      customerAge: booking?.customer_age,
      customerGender: booking?.customer_gender,
      customerPackage: [],
      packagePrice: 0,
      dateOfBirth: "",
    },
  ]);
  const timer = useRef<any>(0);
useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    getBookingById(id);
  }, []);
useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (booking.center && booking.cityid) {
      getCCPackage(booking?.center?.id, booking.cityid, "");
    }
    if (booking.centre_address) {
      setCentreType(booking?.centre_address?.type);
    }
  }, [booking]);
useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (centreType === "postpaid") {
      setWithoutPayment(true);
    } else if (centreType === "prepaid") {
      setWithoutPayment(false);
    }
  }, [centreType]);
useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (booking?.additional_members !== undefined) {
      booking.additional_members &&
        booking.additional_members.length > 0 &&
        booking.additional_members.map((member: any, index: number) => {
          if (Number(member.id) === Number(aid)) {
            setInputList([
              {
                customerDesignation: member?.designation,
                designation: member?.designation,
                customerName: member?.customer_name,
                customerAge: member?.customer_age,
                customerGender: member?.customer_gender,
                customerPackage: [],
                packagePrice: 0,
                dateOfBirth: "",
              },
            ]);
            setAddnPkgs(member.packages);
          }
        });
    } else {
      setInputList([
        {
          customerDesignation: booking?.designation,
          designation: booking?.designation,
          customerName: booking?.customer_name,
          customerAge: booking?.customer_age,
          customerGender: booking?.customer_gender,
          customerPackage: [],
          packagePrice: 0,
          dateOfBirth: "",
        },
      ]);
    }
  }, [booking, aid]);
  const handlePackage = (index: number, customerPackages: any) => {
    const list = [...inputList];
    list[index]["customerPackage"] = customerPackages;
    setInputList(list);
    let accumulatedPrice: any = 0;
    if (customerPackages && customerPackages.length > 0) {
      customerPackages.map((item: any) => {
        accumulatedPrice = accumulatedPrice + item?.package_lab_prices;
      });
    }
    list[index]["packagePrice"] = accumulatedPrice;
    setInputList(list);

    let allPackagePrice = 0;
    inputList &&
      inputList.map((rowItem: any) => {
        allPackagePrice = allPackagePrice + rowItem?.packagePrice;
      });
    setTotalPrice(Math.floor(allPackagePrice));
  };
useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (totalPrice < 0) {
      setTotalPrice(0);
    }
  }, [totalPrice]);
useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setNetPrice(totalPrice - discount);
  }, [totalPrice, discount]);

useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (packageDetails) {
      let packIds: any = [];
      packageDetails.map((item: any) => {
        packIds.push(item?.id);
      });

      setPackages(packIds);
    }
  }, [packageDetails]);

  const submitForm = async (e: any) => {
    e.preventDefault();
    let packagesIds = new Array();
    inputList &&
      inputList[0]?.customerPackage.map((item: any) => {
        packagesIds.push(item?.id);
      });
    let payment = new Array();
    paymentInfo &&
      paymentInfo.length > 1 &&
      paymentInfo.map((item: any) => {
        if (item.isChecked) {
          payment.push({
            amount: item.amount,
            link_type: item.link_type,
            paymentid: item.paymentid,
          });
        }
      });

    const data: any = {
      id: aid === "aid" ? id : Number(aid),
      type: type,
      operation: "add_package",
      packages: String(packagesIds),
      payment_information: payment,
    };
    if (withoutPayment) {
      delete data["payment_information"];
    }
    await postAddRemoveTest(data);
    getBookingById(id);
  };

  return (
    <div style={{ width: "100%" }} className="data-table">
      <form
        autoComplete="off"
        style={{ width: "100%", padding: "0 20px 20px 20px" }}
        onSubmit={submitForm}
      >
        <Grid container item xs={12}>
          <Grid container item xs={12}>
            <Grid item xs={12} style={{ marginTop: 20 }}>
              <Autocomplete
                id="package"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let packs: any = [];
                    newValue.map((val: any) => {
                      let obj = JSON.parse(JSON.stringify(val, null, " "));
                      packs.push(obj);
                    });
                    handlePackage(0, packs);
                  }
                }}
                multiple
                disableClearable
                options={ccpackageList.results || []}
                limitTags={0}
                // disabled={ccpackageList.results === undefined}
                freeSolo
                disableCloseOnSelect
                aria-required
                onInputChange={(event, newInputValue) => {
                  getCCPackage(
                    booking?.center?.id,
                    booking?.cityid,
                    newInputValue
                  );
                }}
                value={inputList[0]?.customerPackage}
                getOptionLabel={(option: any) => {
                  return (
                    option.name +
                    "(" +
                    option.code +
                    ")" +
                    ", Rs. " +
                    option?.package_lab_prices
                  );
                }}
                getOptionDisabled={(option: any) => {
                  const packages = (inputList[0]?.customerPackage).concat(
                    addnPkgs.length === 0 ? booking?.packages : addnPkgs
                  );

                  const packID = packages.map((pack: any) => pack.id);
                  return packID.includes(option.id);
                }}
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.package_city_prices
                      ? option.name.toString() +
                        ", " +
                        option.package_city_prices.tat_time +
                        ", Rs. " +
                        option?.package_city_prices.offer_price +
                        "/-"
                      : option.name.toString() +
                        ", " +
                        option.tat_time +
                        ", Rs." +
                        option?.package_lab_prices +
                        "/-"}
                  </React.Fragment>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="input"
                    placeholder="Package"
                    variant="outlined"
                    label="Test Name"
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <div className="price-details-new-booking">
                <table style={{ width: "100%", margin: "0" }}>
                  <thead>
                    <tr>
                      <td className="cell" align="center">
                        S No.
                      </td>
                      <td className="cell" align="center">
                        Test code
                      </td>

                      <td className="cell" align="center">
                        Test Name
                      </td>

                      <td className="cell" align="center">
                        TAT
                      </td>
                      <td className="cell" align="center">
                        Price
                      </td>
                      {/* <td className="cell" align="center">
                        Camp Discount
                      </td> */}
                    </tr>
                  </thead>
                  <tbody>
                    {inputList[0]?.customerPackage &&
                      inputList[0]?.customerPackage.length > 0 &&
                      inputList[0]?.customerPackage.map(
                        (packageItem: any, index: any) => {
                          return (
                            <tr>
                              <td className="cell" align="center">
                                {index + 1}
                              </td>
                              <td className="cell" align="center">
                                {packageItem?.code}
                              </td>
                              <td className="cell" align="left">
                                <a
                                  className={classes.packageLink}
                                >
                                  {packageItem?.name}
                                  <br />
                                  Fasting : {packageItem?.fasting_time}
                                </a>
                              </td>
                              <td className="cell" align="center">
                                {packageItem?.tat_time}
                              </td>
                              <td className="cell" align="center">
                                ₹ {packageItem?.package_lab_prices}
                              </td>
                              {/* <td className="cell" align="center">
                                    {campCouponData !== ""
                                      ? campCouponData.packages.map(
                                          (val: any) => {
                                            if (packageItem?.id === val.id) {
                                              return (
                                                "₹" +
                                                Math.floor(
                                                  (packageItem?.package_lab_prices *
                                                    campCouponData.discount) /
                                                    100
                                                )
                                              );
                                            } else {
                                              return "";
                                            }
                                          }
                                        )
                                      : ""}
                                  </td> */}
                            </tr>
                          );
                        }
                      )}

                    <tr>
                      <td colSpan={4}>
                        <table style={{ width: "100%" }}>
                          <tr>
                            <td
                              className="cell"
                              align="left"
                              rowSpan={4}
                              colSpan={2}
                              style={{ width: "60%" }}
                              valign="top"
                            >
                              <Grid container spacing={1} direction="row">
                                {/* <Grid item xs={12}>
                                  <p>Enter Coupon</p>
                                </Grid>
                                <Grid item xs={8}>
                                  {campCouponCode !== "" ? (
                                    <TextField
                                       
                                      placeholder="Enter Coupon"
                                      value={campCouponCode}
                                      variant="outlined"
                                      style={{
                                        width: "100%",
                                        margin: "0",
                                        padding: "0",
                                      }}
                                    />
                                  ) : (
                                    <Autocomplete
                                      id="coupon"
                                      onChange={(event, newValue) => {
                                        if (newValue) {
                                          let obj = JSON.parse(
                                            JSON.stringify(newValue, null, " ")
                                          );
                                          setCoupon(obj.id as Number);
                                          setCouponCode(obj.code as string);
                                          // setCouponType(obj.is_red_cash);
                                        }
                                      }}
                                      inputValue={couponCode}
                                      options={couponList?.results || []}
                                      freeSolo
                                      blurOnSelect
                                      onInputChange={(event, newInputValue) => {
                                        clearTimeout(timer.current);
                                        setCouponCode(newInputValue);
                                        timer.current = setTimeout(() => {
                                          getCoupons(
                                            `${newInputValue}&org_type=homedx`
                                          );
                                        }, 1000);
                                        if (newInputValue === "") {
                                          setCoupon(0);
                                          setDiscount(0);
                                          setTncMessage("");
                                          setCouponMessage("");
                                        }
                                      }}
                                      getOptionLabel={(option: any) =>
                                        option.code
                                      }
                                      getOptionDisabled={(option: any) =>
                                        option.minimum_price > totalPrice
                                      }
                                      renderInput={(params) => (
                                        <TextField
                                           
                                          {...params}
                                          placeholder="Enter Coupon"
                                          variant="outlined"
                                          disabled={
                                            inputList[0]?.customerPackage
                                              ?.length === 0
                                          }
                                          style={{
                                            width: "100%",
                                            margin: "0",
                                            padding: "0",
                                          }}
                                        />
                                      )}
                                    />
                                  )}
                                </Grid>
                                <Grid item xs={4}>
                                  <Button
                                    variant="contained"
                                    fullWidth
                                    color="primary"
                                    onClick={applyCoupon}
                                    disabled={campCouponCode !== ""}
                                  >
                                    {campCouponCode !== ""
                                      ? "Camp Coupon Applied"
                                      : "Apply"}
                                  </Button>
                                </Grid>
                                <p
                                  style={{
                                    color: "#8e24aa",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    alignItems: "center",
                                  }}
                                >
                                  {couponMessage} <br />
                                  {tncMessage}
                                </p> */}
                              </Grid>
                            </td>
                            <td
                              className="cell"
                              align="right"
                              style={{ width: "20%" }}
                            >
                              Gross
                            </td>
                            <td
                              className="cell"
                              align="center"
                              style={{ width: "20%" }}
                            >
                              ₹ {Math.floor(totalPrice)}
                            </td>
                          </tr>
                          {/* <tr>
                            <td
                              className="cell"
                              align="right"
                              style={{ width: "20%" }}
                            >
                              RedCash Discount
                            </td>
                            <td
                              className="cell"
                              align="center"
                              style={{ width: "20%" }}
                            >
                              ₹ {redDisc > 0 ? Math.floor(redDisc) : 0}
                            </td>
                          </tr>
                          <tr>
                            <td className="cell" align="right">
                              Phlebo Cost
                            </td>
                            <td className="cell" align="center">
                              ₹ {extraCharge ? "+ 200" : "0"}
                            </td>
                          </tr> */}
                          <tr>
                            <td
                              className="cell"
                              align="right"
                              style={{ width: "20%" }}
                            >
                              Discount
                            </td>
                            <td
                              className="cell"
                              align="center"
                              style={{ width: "20%" }}
                            >
                              ₹ {Math.floor(discount)}
                            </td>
                          </tr>
                          <tr>
                            <td className="cell" align="right">
                              <h4 className="totalPrice">Net Amount</h4>
                            </td>
                            <td className="cell" align="center">
                              <h4 className="totalPrice">
                                ₹ {Math.floor(netPrice)}
                              </h4>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Grid>
         
            <Grid item xs={12} style={{ textAlign: "center" }}>
              <Button
                // onClick={() => submitForm()}
                type="submit"
                color="primary"
                variant="contained"
                // disabled={!withoutPayment && paid === 0}
              >
                Proceed to Add
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  booking: state.OffLineSupporteReducer.booking,
  packageList: state.OffLineSupporteReducer.packageList,
  ccpackageList: state.OffLineSupporteReducer.ccpackageList,
});

export default connect(mapStateToProps, {
  getBookingById,
  getCCPackage,
  postAddRemoveTest,
})(AddCorporateTest);
